// Renders a destructive ``*`` after a FieldLabel via CSS so the required marker
// stays out of the label's accessible name (queries match the bare label text).
export const REQUIRED_MARK =
  "tw:after:ml-0.5 tw:after:text-destructive tw:after:content-['*']";
